module.exports = __webpack_public_path__ + "img/zhongxinGH5.3ab0e331.png";